import { render, staticRenderFns } from "./questionnaireDel.vue?vue&type=template&id=37443d0a&scoped=true&"
import script from "./questionnaireDel.vue?vue&type=script&lang=js&"
export * from "./questionnaireDel.vue?vue&type=script&lang=js&"
import style0 from "./questionnaireDel.vue?vue&type=style&index=0&id=37443d0a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37443d0a",
  null
  
)

export default component.exports